import { renderMarketingPage, SUPPORT_EMAIL } from './shared.js';

export function renderAbout(container, signedIn) {
  const body = `
    <main class="mkt-main">
      <section class="mkt-page-hero">
        <h1>About Simustage</h1>
        <p>We think the best way to understand something is to build it, tune it, and watch it respond.</p>
      </section>

      <section class="mkt-section mkt-prose">
        <h2>Our story</h2>
        <p>
          Simustage started from a simple frustration: textbooks and slide decks are great at
          telling you how something works, but terrible at letting you find out for yourself.
          A pendulum's period, a titration curve, an orbit's shape — these are things you feel
          once you can nudge a variable and watch the result change in front of you.
        </p>
        <p>
          So we built a place where describing what you want to learn is enough to get a real,
          interactive lesson — a simulation, a working model, or a quiz — that you can keep
          refining until it clicks.
        </p>

        <h2>What we believe</h2>
        <ul>
          <li><strong>Understanding beats memorizing.</strong> Interactive material sticks longer than static notes.</li>
          <li><strong>Learning has no age limit.</strong> The same curiosity that helps a ten-year-old grasp fractions helps a graduate student grasp control systems.</li>
          <li><strong>You own what you build.</strong> Courses and topics you create are yours to keep, revisit, and share.</li>
        </ul>

        <h2>Get in touch</h2>
        <p>
          Questions, feedback, or ideas for a subject we should support better? Write to us at
          <a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a> or visit our
          <a href="#/contact">contact page</a>.
        </p>
      </section>
    </main>
  `;
  renderMarketingPage(container, '/about', signedIn, body);
}
